import React from 'react';
import { DataContextProvider } from './context/DataContext';
import Slider from './components/Slider';
import List from './components/List';
import Filter from './components/Filter';
import FilterToggle from './components/FilterToggle';

const HousingTypes = () => (
  <DataContextProvider>
    <div className="layout--desk">
      <div className="layout__cell layout__cell--fit housing-types__aside">
        <Filter />
      </div>
      <div className="layout__cell layout__cell--fill housing-types__main">
        <Slider />
        <FilterToggle />
        <List showResults />
      </div>
    </div>
  </DataContextProvider>
);

export default HousingTypes;
